import React from "react";
import {
  Box,
  Skeleton,
  Card,
  CardContent
} from "@mui/material";

const ShimmerDashboard = () => {
  return (
    <Box sx={{ backgroundColor: "#e0f1ef", minHeight: "100vh" }}>
      {/* Header Skeleton */}
      <Box
        sx={{
          backgroundColor: "#fff",
          p: 2,
          px: 4,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Skeleton variant="text" width={180} height={30} />

        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Skeleton variant="rectangular" width={160} height={36} />
          <Skeleton variant="circular" width={36} height={36} />
        </Box>
      </Box>

      {/* Cards Skeleton */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 3,
          p: 2,
          flexWrap: "wrap",
        }}
      >
        {[1,2,3,4].map((item) => (
          <Card
            key={item}
            sx={{
              width: 180,
              height: 160,
              borderRadius: 2,
              boxShadow: 2,
            }}
          >
            <CardContent
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Skeleton variant="circular" width={56} height={56} />
              <Skeleton
                variant="text"
                width={140}
                height={24}
                sx={{ mt: 2 }}
              />
            </CardContent>
          </Card>
        ))}
      </Box>
    </Box>
  );
};

export default ShimmerDashboard;